import React, { useState, useEffect } from 'react'
import '../CI/COD.css'
import { getRequest } from '../../globalhelper/helper'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import _ from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const InternalPlan_Dropdown = props => {
  const [state, setState] = useState({
    showtable: false,
    formData: {
      createddate: '',
      vendorname: '',
      vendorid: '',
      ipnumber: '',
      taxcode: '',
      periodfrom: '',
      periodto: '',
      status: '',
      orgname: ''
    },
    tableData: [],
    dropdown_orgname: [],
    dropdown_vendorid: [],
    dropdown_vendorname: [],
    dropdown_ipnumber: [],
    dropdown_status: [],
    companyDetails: [],
    error: false,
    errorMessage: '',
    redirect: false,
    SearchJSON: []
  })

  useEffect(() => {
    localStorage.setItem('pageName', 'Search InternalPlan')

    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        const responseData = _.sortBy(response?.res?.data, 'orgname')
        const arr = responseData
          ?.map(item => item.orgname)
          ?.sort((a, b) => a.localeCompare(b))
        setState(prev => ({
          ...prev,
          dropdown_orgname: arr,
          companyDetails: responseData
        }))
      })
      .catch(err => console.log(err))

    getRequest(`api/edureka/getPORemainingValues`).then(res => {
      const responseData = res?.res?.data?.sort((a, b) => a.localeCompare(b))
      setState(prev => ({
        ...prev,
        dropdown_status: responseData
      }))
    })
  }, [])

  useEffect(() => {
    if (state.companyDetails.length === 1) {
      handleChange('orgname', state.companyDetails[0].orgname)
    }
  }, [state.companyDetails])

  const handleChange = (name, value) => {
    setState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        [name]: value || ''
      }
    }))

    if ((name === 'orgname', value !== null)) {
      handleRemainingAPIs(value)
    }
  }

  const handleSearch = () => {
    const { orgname } = state.formData

    if (!orgname) {
      setState(prev => ({
        ...prev,
        error: true,
        errorMessage: 'Please select all the required fields'
      }))
      return
    }

    const { ipnumber, vendorname, vendorid, status } = state.formData
    const id = state.companyDetails.filter(item => item.orgname === orgname)
    const companyid = id.map(item => item.orgid)

    getRequest(
      `api/edureka/getIPData?ipnumber=${ipnumber}&vendorname=${vendorname}&status=${status}&vendorid=${vendorid}&orgid=${companyid[0]}`
    ).then(res => {
      const temp = JSON.parse(res.res.data)
      if (temp.length) {
        setState(prev => ({
          ...prev,
          tableData: temp,
          showtable: true,
          error: false
        }))
      } else {
        setState(prev => ({
          ...prev,
          error: true,
          errorMessage: 'No data found. Please try some other combination'
        }))
      }
    })
  }

  const handleReset = () => {
    setState(prev => ({
      ...prev,
      showtable: false,
      error: false,
      formData: {
        createddate: '',
        vendorname: '',
        vendorid: '',
        ipnumber: '',
        taxcode: '',
        periodfrom: '',
        periodto: '',
        status: '',
        orgname: ''
      }
    }))
  }

  const handleIP = item => {
    const planid = item['IP Number']
    const id = state.companyDetails.filter(
      item => item.orgname === state.formData.orgname
    )
    const companyid = id.map(item => item.orgid)

    localStorage.setItem(
      'api',
      `api/edureka/getUpdatedDataFromDB`
    )
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": {
        "Organization ID": companyid[0],
        "PE Number": planid,
      },
      "Module": localStorage.getItem('module'),
      "screenName": "InternalPlan"
    }))
    window.open(
      `/Dynamic_Forms?token=InternalPlan&action=edit&orgId=${companyid[0]}&docId=${planid}`,
      '_blank'
    )
  }

  const onBack = () => {
    setState(prev => ({
      ...prev,
      redirect: false,
      SearchJSON: []
    }))
  }

  const handleRemainingAPIs = value => {
    if (!value) {
      return;
    }
    const id = state.companyDetails.filter(item => item.orgname === value)
    const companyid = id.map(item => item.orgid)

    companyid.length > 0 && getRequest(`api/edureka/getPOVendor?orgid=${companyid[0]}`).then(res => {
      const responseData = JSON.parse(res.res.data)
      const vendorName = responseData
        .map(item => item['Vendor Name'])
        ?.sort((a, b) => a.localeCompare(b))
      const vendorID = responseData
        .map(item => item['Vendor ID'])
        ?.sort((a, b) => a.localeCompare(b))

      setState(prev => ({
        ...prev,
        dropdown_vendorname: vendorName,
        dropdown_vendorid: vendorID
      }))
    })

    companyid.length > 0 && getRequest(`api/dashboard/getIP2?orgid=${companyid[0]}`).then(res => {
      const responseData = JSON.parse(res.res.data)
      const IPNumber = responseData
        .map(value => value['IP Number'])
        ?.sort((a, b) => a.localeCompare(b))

      setState(prev => ({
        ...prev,
        dropdown_ipnumber: IPNumber
      }))
    })
  }

  const {
    dropdown_orgname,
    dropdown_vendorname,
    dropdown_vendorid,
    dropdown_ipnumber,
    dropdown_status,
    formData,
    showtable,
    tableData,
    error,
    errorMessage,
    redirect,
    SearchJSON
  } = state

  if (redirect) {
    return (
      <VR2_Forms
        screenName={'InternalPlan'}
        screenAction={'edit'}
        From_SearchJSON={SearchJSON}
        onBack={onBack}
      />
    )
  }

  return (
    <>
      {' '}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>Search Internal Plan</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xl={2}>
              <Autocomplete
                options={state.dropdown_orgname}
                value={state.formData.orgname}
                onChange={(e, newValue) => handleChange('orgname', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Organization Name'
                    variant='outlined'
                    size='small'
                    style={{ width: 200 }}
                  />
                )}
              />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete
                options={state.dropdown_vendorname}
                value={state.formData.vendorname}
                onChange={(e, newValue) => handleChange('vendorname', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor Name'
                    variant='outlined'
                    size='small'
                    style={{ width: 200 }}
                  />
                )}
              />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete
                options={state.dropdown_vendorid}
                value={state.formData.vendorid}
                onChange={(e, newValue) => handleChange('vendorid', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor ID'
                    variant='outlined'
                    size='small'
                    style={{ width: 200 }}
                  />
                )}
              />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete
                options={state.dropdown_ipnumber}
                value={state.formData.ipnumber}
                onChange={(e, newValue) => handleChange('ipnumber', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='IP Number'
                    variant='outlined'
                    size='small'
                    style={{ width: 200 }}
                  />
                )}
              />
            </Grid>

            <Grid item xl={2}>
              <Autocomplete
                options={state.dropdown_status}
                value={state.formData.status}
                onChange={(e, newValue) => handleChange('status', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Status'
                    variant='outlined'
                    size='small'
                    style={{ width: 200 }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid item xl={1}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button variant='contained' color='error' onClick={handleReset}>
                Reset
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                variant='contained'
                color='warning'
                onClick={() => props.onBack()}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <br />
      {showtable && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>IP Number</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Vendor ID</TableCell>
                <TableCell>Vendor Name</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {tableData
                .sort((a, b) => a['IP Number'].localeCompare(b['IP Number']))
                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Button
                        variant='text'
                        color='primary'
                        onClick={() => handleIP(item)}
                      >
                        {item['IP Number']}
                      </Button>
                    </TableCell>
                    <TableCell>{item.Date}</TableCell>
                    <TableCell>{item['Vendor ID']}</TableCell>
                    <TableCell>{item['Vendor Name']}</TableCell>
                    <TableCell>{item.Status}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {error && <div className='center-screen'>{errorMessage}</div>}
    </>
  )
}

export default InternalPlan_Dropdown